import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import GoogleReviewsBadgeWidget from './GoogleReviewsBadgeWidget';
import { fetchGoogleReviews } from '../utils/googleReviewsApi';

function HomeGoogleReviewsBadge() {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(true);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    let active = true;
    fetchGoogleReviews()
      .then((result) => {
        if (active) setData(result);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  if (!mounted || !visible || loading || !data) {
    return null;
  }

  return createPortal(
    <div className="tsr-greviews-widget-float">
      <GoogleReviewsBadgeWidget
        data={data}
        variant="floating"
        showDismiss
        onDismiss={() => setVisible(false)}
      />
    </div>,
    document.body
  );
}

export default HomeGoogleReviewsBadge;
